/**
 * Shared types and helpers for the upload command family.
 *
 * Kept in a dedicated module so the legacy multipart path (``upload.ts``) and
 * the direct-to-MinIO path (``upload-direct.ts``) can share the summary shape
 * and printing helper without introducing a circular import between them.
 */

import { success, warn } from '../output.js'

export interface UploadSummary {
  totalFiles: number
  uploaded: number
  skipped: number
  duplicates: number
  folders: number
  docIds: string[]
  skippedDetails: Array<{ file_name: string; reason: string }>
}

export interface UploadOpts {
  workspace?: string
  watch?: boolean
  dryRun?: boolean
  json?: boolean
  config?: string
  manifest?: string
  log?: string
  resume?: boolean
  failFast?: boolean
  root?: string
  limit?: string
  s3?: boolean
  folder?: string
  /** Work-product type for the uploaded docs (source, skill, memory,
   *  artifact, webpage). Use ``skill`` with ``--folder skills/<slug>``
   *  to upload a SKILL.md the agent will pick up on slash invocation. */
  wpType?: 'source' | 'skill' | 'memory' | 'artifact' | 'webpage'
}

export function printSummary(summary: UploadSummary): void {
  console.log('')
  console.log('Upload summary:')
  console.log(`  Files found:  ${summary.totalFiles}`)
  success(`  Uploaded:     ${summary.uploaded}`)
  if (summary.skipped > 0) {
    warn(`  Skipped:      ${summary.skipped}`)
  }
  console.log(`  Folders:      ${summary.folders}`)

  if (summary.skippedDetails.length > 0) {
    console.log('')
    warn('Skipped files:')
    for (const s of summary.skippedDetails) {
      warn(`  ${s.file_name}: ${s.reason}`)
    }
  }
}
